import { all } from "redux-saga/effects";
import { userWatcher } from "../app/auth/sagas";

export function* rootSaga() {
  yield all([userWatcher()]);
}

export default rootSaga;
